import { ReactNode } from 'react';

interface PageTransitionProps {
  children: ReactNode;
}

const PageTransition = ({ children }: PageTransitionProps) => {
  return (
    <div className="animate-[fade-in-up_0.3s_ease-in-out_forwards]">
      {children}
    </div>
  );
};

export default PageTransition;
